import React, { use, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { deletePartner } from "../../features/admin/PartnerSlice";
import MediaModal from "../../components/admin/MediaModal";
import { toast } from "react-toastify";
import { fetchMedias } from "../../features/admin/MediaSlice";
import ApiCustom from "../../utils/ApiCustom";
import { TrashIcon } from "@heroicons/react/24/solid";
import ConfirmDeleteModal from "../../components/ConfirmDeleteModal";

const getUserPermissions = () => {
  const permissions = localStorage.getItem("permissions");
  return permissions
    ? JSON.parse(permissions).map((p) => p.permissionSlug)
    : [];
};

const userId = localStorage.getItem("userId");
const hasPermission = (requiredPermission) => {
  if (userId == 1) {
    return true;
  }
  const userPermissions = getUserPermissions();
  return userPermissions.includes(requiredPermission);
};

const AvatarImageModal = ({
  onClose,
  onPress,
  avatarType = false,
  imageableId = null,
  imageableType = null,
  imageType = null,
}) => {
  const dispatch = useDispatch();
  const { medias, status, error } = useSelector((state) => state.medias);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [activeTab, setActiveTab] = useState("Hội viên");
  const [filtedMedias, setFiltedMedias] = useState();
  const [isConfirmDeleteMediaOpent, setIsConfirmDeleteMediaOpent] = useState();
  const [deleteId, setDeleteId] = useState(null);

  useEffect(() => {
    let filtMedias = [];
    filtMedias = medias;
    setFiltedMedias(filtMedias);
  }, [medias]);

  const handleSaveMedia = async (url) => {
    const res = await dispatch(fetchMedias());
    if (res?.payload) {
      onPress(res?.payload?.find((media) => media.url === url));
    }
    onClose();
  };

  const handleOpenDeleteMediaMoal = async (media) => {
    setDeleteId(media.id);
    setIsConfirmDeleteMediaOpent(true);
  };

  const handleCloseDeleteMediaMoal = async () => {
    setIsConfirmDeleteMediaOpent(false);
  };

  const handleDeleteMedia = async () => {
    const res = await ApiCustom.delete(`/delete-media/${deleteId}`);
    if (res.status === 200) {
      setFiltedMedias((prev) => prev.filter((media) => media.id !== deleteId));
      toast.success("Xóa hình ảnh thành công!");
    } else {
      toast.error("Xóa không thành công!");
    }

    handleCloseDeleteMediaMoal();
  };

  const handleOpenModal = (media = null) => {
    setSelectedMedia(media);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedMedia(null);
  };

  const handleDelete = (id) => {
    dispatch(deletePartner(id)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        toast.success("Xóa hình ảnh thành công!");
        handleCloseModal();
      } else {
        toast.error("Đã xảy ra lỗi khi xóa hình ảnh!");
      }
    });
  };

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchMedias());
    }
  }, [status, dispatch]);

  if (status === "loading") return <p>Loading...</p>;
  if (status === "failed") return <p>Error: {error}</p>;

  const renderTabContent = () => {
    if (activeTab === "Hình ảnh") {
      const filtedData = filtedMedias?.filter(
        (media) =>
          media.imageableType != "companie" && media.imageableType != "user"
      );
      return filtedData?.length > 0 ? (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2">
          {filtedData.map((media) => (
            <div
              key={media.id}
              className="relative border rounded-lg overflow-hidden shadow-sm cursor-pointer"
              onClick={() => onPress(media)}
            >
              <img
                src={media.url}
                alt="Media"
                className="w-full h-32 lg:h-34 xl:h-48 object-contain"
                loading="lazy"
              />
              {hasPermission("MEDIA_DELETE") && (
                <button
                  className="absolute flex justify-center w-10 top-2 right-2 bg-red-500 text-white rounded-lg p-1 shadow-md hover:bg-red-600"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpenDeleteMediaMoal(media);
                  }}
                >
                  <TrashIcon className="w-5 h-5" />
                </button>
              )}
            </div>
          ))}
        </div>
      ) : (
        <p className="text-center text-gray-500">Chưa có ảnh được tải lên</p>
      );
    } else if (activeTab === "Hội viên") {
      const filtedData = filtedMedias?.filter(
        (media) =>
          media.imageableType == "companie" || media.imageableType == "user"
      );
      return filtedData?.length > 0 ? (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2">
          {filtedData.map((media) => (
            <div
              key={media.id}
              className="relative border rounded-lg overflow-hidden shadow-sm cursor-pointer"
              onClick={() => onPress(media)}
            >
              <img
                src={media.url}
                alt="Avatar"
                className="w-full h-32 lg:h-34 xl:h-48 object-contain"
                loading="lazy"
              />
              {hasPermission("MEDIA_DELETE") && (
                <button
                  className="absolute flex justify-center w-10 top-2 right-2 bg-red-500 text-white rounded-lg p-1 shadow-md hover:bg-red-600"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpenDeleteMediaMoal(media);
                  }}
                >
                  <TrashIcon className="w-5 h-5" />
                </button>
              )}
            </div>
          ))}
        </div>
      ) : (
        <p className="text-center text-gray-500">Chưa có ảnh được tải lên</p>
      );
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50 p-4 overflow-y-auto">
      <div className="bg-base-100 rounded-lg shadow-xl xl:w-5/6 lg:w-11/12 md:w-11/12 sm:w-11/12 w-11/12 max-h-[90vh] overflow-y-auto">
        <div className="">
          <div className="sticky top-0 bg-base-100 z-10 p-6 pb-2">
            <h1 className="text-2xl font-semibold mb-4">Quản lý hình ảnh</h1>
            <div className="flex justify-between items-center mb-4">
              <button
                onClick={() => handleOpenModal()}
                className="btn btn-success transition-colors px-4 py-2 rounded"
              >
                + Thêm hình ảnh
              </button>
              <button
                onClick={onClose}
                className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-base-700 bg-base-100 hover:bg-base-200"
              >
                X
              </button>
            </div>
            <div className="flex border-b mb-4 pt-0">
              <button
                className={`px-4 py-2 ${
                  activeTab === "Hội viên"
                    ? "border-b-2 border-blue-500 text-blue-500"
                    : "text-gray-500"
                }`}
                onClick={() => setActiveTab("Hội viên")}
              >
                Hội viên
              </button>
              {hasPermission("MEDIA_SHOW_LIST") && (
                <button
                  className={`px-4 py-2 ${
                    activeTab === "Hình ảnh"
                      ? "border-b-2 border-blue-500 text-blue-500"
                      : "text-gray-500"
                  }`}
                  onClick={() => setActiveTab("Hình ảnh")}
                >
                  Hình ảnh
                </button>
              )}
            </div>
          </div>

          <div className="p-6 pt-0">
            {/* Tab Content */}
            {renderTabContent()}
          </div>

          {isModalOpen && (
            <MediaModal
              imageableId={imageableId}
              imageableType={activeTab == "Hội viên" ? imageableType : null}
              imageType={activeTab == "Hội viên" ? imageType : null}
              onSaveMedia={avatarType ? handleSaveMedia : null}
              avatarType={avatarType}
              media={selectedMedia}
              onClose={handleCloseModal}
              onDelete={() => handleDelete(selectedMedia?.id)}
            />
          )}

          <ConfirmDeleteModal
            isOpen={isConfirmDeleteMediaOpent}
            onClose={handleCloseDeleteMediaMoal}
            onConfirm={handleDeleteMedia}
          />
        </div>
      </div>
    </div>
  );
};

export default AvatarImageModal;
